export default __webpack_public_path__ + "static/media/github_auth.628d0e46.png";